import React, { useEffect } from 'react';
import { useLocation, Outlet } from 'react-router-dom';
import TopBar from './TopBar/';
import MobileMenu from './MobileMenu';
import styles from './MainLayout.module.scss';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { setIsMobile, closeFileExplorer } from '../../../store/app/slice';
import { openMobileHistory, closeMobileHistory } from '../../../store/chat/slice';

const MainLayout: React.FC = () => {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const { isMobile, isFileExplorerOpen } = useAppSelector((state) => state.app);
  const { isMobileHistoryOpen } = useAppSelector((state) => state.chat);
  const [showMobileMenu, setShowMobileMenu] = React.useState(false);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      dispatch(setIsMobile(mobile));
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Call once on mount to set initial state
    return () => window.removeEventListener('resize', handleResize);
  }, [dispatch]);

  const toggleMobileMenu = () => {
    setShowMobileMenu(!showMobileMenu);
  };

  const isChatPage = location.pathname.startsWith('/chat');

  return (
    <div className={styles.appContainer}>
      <TopBar onMobileMenuToggle={toggleMobileMenu} isChatPage={isChatPage} />

      <main className={styles.mainContent}>
        <Outlet />
      </main>

      <MobileMenu
        isOpen={isMobile && showMobileMenu}
        onClose={() => setShowMobileMenu(false)}
        onShowHistory={() => dispatch(openMobileHistory())}
        isChatPage={isChatPage}
      />
      {isMobile && (showMobileMenu || isMobileHistoryOpen || isFileExplorerOpen) && (
        <div
          className={`${styles.backdropOverlay} ${styles.visible}`}
          onClick={() => {
            setShowMobileMenu(false);
            dispatch(closeMobileHistory());
            dispatch(closeFileExplorer());
          }}
        />
      )}
    </div>
  );
};

export default MainLayout;
